//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloudFileSetupApi } from '@/api/config';
export default {
  props: {
    fromData: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      loading: false,
      form: {
        yihaotong_appid: '',
        yihaotong_appsecret: ''
      }
    };
  },
  watch: {
    fromData: {
      handler: function handler(val) {
        var _this = this;
        this.fromData.map(function (item) {
          if (item.field == 'yihaotong_appid') {
            _this.form.yihaotong_appid = item.value;
          } else if (item.field == 'yihaotong_appsecret') {
            _this.form.yihaotong_appsecret = item.value;
          }
        });
      },
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.setup('yiht_config', _this2.form);
        }
      });
    },
    setup: function setup(id, data) {
      var _this3 = this;
      this.loading = true;
      cloudFileSetupApi(id, data).then(function (res) {
        _this3.loading = false;
      }).catch(function (err) {
        _this3.loading = false;
      });
    }
  }
};